import MultipleImageInput from './MultipleImageInput';

export default MultipleImageInput;
